import React from 'react';
import {HashRouter as Router, Switch, Route} from 'react-router-dom';
import styled from 'styled-components';

import Star from './SvgComponents/star.js';
import SineWave from './SvgComponents/SineWave.js';
import Plus from './SvgComponents/Plus.js';
import Triangle from './SvgComponents/Triangle.js';
import Home from './Components/Home/Home';
import './App.css';
import TopNavBar from './Components/TopAppBar/TopAppBar';

export default function App() {
  return (
    <Router >
        <TopNavBar/>
          <Star angle="-27.38" scale="0.77" left="85" top="14" thick="6"/>
          <Star angle="28" scale="0.47" left="10" top="84" thick="5" color="#34A853"/>
          <SineWave angle="15.14" scale="0.92" left="6" top="31" />
          <Plus angle="-60" scale="0.46" left="40" top="80" thick="3"/>
          <Plus angle="40" scale="0.40" left="60" top="20" thick="3" color="#FF9900"/>
          <Triangle angle="20" scale="0.8" left="80" top="70"/>
          <Triangle angle="-10" scale="0.4" left="20" top="10" color="#34A853"/>
          <Switch>
            <Route path="/works" exact component={Works}/>
            <Route path="/about" exact component={About}/>
            <Route path="/" exact component={Home}/>
          </Switch>
    </Router>
  );
}
const PageWrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflowX: hidden;
  overflowY: hidden;
  z-index: -1;
`

function Works() {
  return (
    <div>Hello This are my Works</div>
  );
}
function About() {
  return (
    <div>Hello This is About Me</div>
  );
}
